import { useState, useEffect } from 'react';
import { useSearchParams } from "react-router-dom";
import { HatchSign, MintSign } from '../helpers/signMessage'

import Navbar from '../components/Navbar'
import Footer from '../components/Footer'

import minting_card from "../assets/duck-images/minting_board.webp"
import items from "../assets/duck-images/list_of_items.png"



function Farm({ ConnectWalletFunc, state, setState, disconnectWallet, nftContract, myWeb3 }) {

    let [searchParams, setSearchParams] = useSearchParams();
    const invitedBy = searchParams.get("inv") || "0x0000000000000000000000000000000000000000";

    const [show, setShow] = useState(1);

    const [qty, setQty] = useState(1);
    const [price, setPrice] = useState(0);
    const [minted, setMinted] = useState(0);
    const [itemsRange, setItemsRange] = useState({ start: 0, end: 1000 });  // means available items ki range like 0~1000, 1001~4000, 4001~10000 
    const [totalSupply, setTotalSupply] = useState("50,000");
    const [userNFTs, setUserNFTs] = useState([]);


    const handleQuantity = (action) => {
        if (action == "+" && qty < 20 && (qty + minted) < itemsRange.end) {
            setQty(qty + 1)
        }
        else if (action == "-" && qty > 1) {
            setQty(qty - 1)
        }
    }
    async function getMinted() {
        const MINTED = parseInt(await nftContract.methods.minted().call())
        // alert(MINTED)
        setMinted(MINTED)
        setQty(1)

        const Presale = parseInt(await nftContract.methods.Presale().call())
        const MINT_PRICE = await nftContract.methods.MINT_PRICE().call()

        //  999       1000
        if (MINTED < Presale) {
            setPrice(MINT_PRICE);
            setItemsRange({ start: MINTED, end: Presale }); // 0~1000
            return
        }


        const Publicsale = parseInt(await nftContract.methods.Publicsale().call())
        //  19,999      20,000
        if (MINTED < Publicsale) {
            // console.log("Publicsale");
            setItemsRange({ start: MINTED, end: Publicsale })
            return
        }
    }
    async function getData() {
        const data = await nftContract.methods.TOTAL_SUPPLY().call()
        setTotalSupply(data)
        // alert(await nftContract.methods.owner().call())
    }
    async function getUserNFts() {
        const minter = await myWeb3.eth.getAccounts();
        const nfts = parseInt(await nftContract.methods.balanceOf(minter[0]).call())
        if (nfts > 0) {
            for (let index = 0; index < nfts; index++) {
                const id = await nftContract.methods.tokenOfOwnerByIndex(minter[0], index).call()
                const nft = await nftContract.methods.tokenURI(id).call()

                // const base64Data = nft.split(",")[1];
                // const decodedData = atob(base64Data);
                // const jsonData = JSON.parse(decodedData);
                
                setUserNFTs((prevNFTs) => [...prevNFTs, nft]);
                // setUserNFTs((prevNFTs) => [...prevNFTs, jsonData, jsonData]);
            }
        }
    }
    async function Mint() {
        try {
            const minter = await myWeb3.eth.getAccounts();
            const Mbalance = await myWeb3.eth.getBalance(minter[0]);
            
            if (Mbalance < (qty * price)) {
                return alert("Insufficient Balance");
            }

            let signature;
            let signature2;
            let signatures = [];
            if (minted <= 1000) {
                signature = await MintSign(minter[0]);
                signature2 = await HatchSign(minter[0]);
                signatures.push(signature)
                signatures.push(signature2)
                // console.log("signature => ", signature);
                console.log(qty, invitedBy, ...signatures);

                //  amount, stake, inviter
                nftContract.methods.MintWL(qty, invitedBy, ...signatures).send({ from: minter[0], value: qty * price })
                    .then(data => {
                        // console.log(data);
                        alert("You have successfully minted")

                        getMinted()
                        getData()
                        getUserNFts()

                    })
                    .catch(err => {
                        console.log(err);
                        if (err.message.includes("User denied transaction signature")) alert("User denied transaction signature")
                        else alert(err.message)
                    })

            } else if (minted <= 20000) {
                signature2 = await HatchSign(minter[0]);
                signatures.push(signature2)

                nftContract.methods.MintPS(qty, invitedBy, ...signatures).send({ from: minter[0], value: qty * price })
                    .then(data => {
                        // console.log(data);
                        alert("You have successfully minted")

                        getMinted()
                        getData()
                        getUserNFts()

                    })
                    .catch(err => {
                        console.log(err);
                        if (err.message.includes("User denied transaction signature")) alert("User denied transaction signature")
                        else alert(err.message)
                    })

            }

        } catch (error) {
            // console.log("error");
            console.log(error);
            alert(error.message)
        }
    }


    useEffect(() => {
        // console.log("nftContract");
        // console.log(nftContract);
        if (nftContract.length != 0) {
            getMinted()
            getData()
            getUserNFts()
        }

    }, [nftContract.length != 0])



    return (
        <>
            <section className='farm_section'>
                <div className="glass">
                    <Navbar ConnectWalletFunc={ConnectWalletFunc} isConnect={state} setIsConnect={setState} disconnectWallet={disconnectWallet} />
                </div>
                <div className="container">
                    {
                        process.env.REACT_APP_ENVIRONMENT !== "production" ?
                            <>
                                {
                                    state?.length == 0 ?
                                        <div className="row justify-content-center align-items-center">
                                            <div className="col-lg-6 col-md-6 col-12 cat_col mb-5">
                                                <div className="card connect_card mx-1">
                                                    <div className="content">
                                                        <button className="btn wallet_btn" onClick={() => ConnectWalletFunc()}>Connect Wallet</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        :
                                        <div className="row justify-content-center align-items-center ">

                                            <div className="col-lg-6 col-md-6 col-12 cat_col farm-desk-col mb-5">
                                                <div className="card mx-1 minting_card w-100">
                                                    <img src={minting_card} alt="image" className='img-fluid t6567 w-100 h-100' />
                                                    <div className="content">
                                                        <div className='d-flex justify-content-center ai-center text-center'>
                                                            <h2>Minting</h2>
                                                        </div>
                                                        <div className='board_content'>
                                                            <div className='w-100'>
                                                                <div className="name">
                                                                    <h3>Minted: {minted} / {itemsRange.end}</h3>
                                                                </div>
                                                            </div>
                                                            <div className='bar'>
                                                                <div className='bg'></div>
                                                                <div className='cont left_text'>
                                                                    {/* <p>0~10,000</p>
                                                                    <p> 0.001 ETH</p> */}
                                                                </div>
                                                                <div className="cont right_text">
                                                                    {/* <p>10,000~50,000</p>
                                                                    <p>1,000~5,000 RICE</p> */}
                                                                    {/* <p>{itemsRange.start}~{itemsRange.end}</p> */}
                                                                    <p> {myWeb3.utils.fromWei(price.toString(), 'ether')} ETH each</p>
                                                                </div>
                                                            </div>
                                                            <div className='counter d-flex justify-content-center text-center align-items-center'>
                                                                <button className='' onClick={() => handleQuantity("-")}>-</button>
                                                                <h2 className='mx-5'>{qty}</h2>
                                                                <button className='' onClick={() => handleQuantity("+")}>+</button>
                                                            </div>
                                                            <div className='mt-2 d-flex justify-content-between'>
                                                                <div className="name d-flex">
                                                                    <h3 style={{ visibility: "hidden" }}>2,770.8 $RICE &nbsp; </h3>
                                                                    <small style={{ visibility: "hidden" }}> at least <span>BUY</span></small>
                                                                </div>
                                                            </div>
                                                            <button className="btn" onClick={() => Mint()}>Want to MINT</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-lg-6 col-md-6 col-12 cat_col farm-desk-col mb-5">
                                                <div className="card mx-1 items_card">
                                                    <img src={items} alt="image" className='img-fluid t6567 h-100' />
                                                    <div className="content rack_1">
                                                        {
                                                            userNFTs.length > 0 && userNFTs.map((__nft, i) => {
                                                                console.log("userNFTs", __nft);
                                                                return <div className="nftCard" key={i}>
                                                                    <div className='text-center w-100'>
                                                                        <img src={__nft?.image} alt="image" style={{ maxWidth: "100px" }} />
                                                                    </div>
                                                                    <div>
                                                                        <p>
                                                                            {__nft?.name}
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            })

                                                        }
                                                    </div>

                                                    <div className="content rack_2">
                                                        {
                                                            userNFTs.length > 0 && userNFTs.map((__nft, i) => {
                                                                console.log("userNFTs", __nft);
                                                                return <div className="nftCard" key={i}>
                                                                    <div className='text-center w-100'>
                                                                        <img src={__nft?.image} alt="image" style={{ maxWidth: "100px" }} />
                                                                    </div>
                                                                    <div>
                                                                        <p>
                                                                            {__nft?.name}
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            })

                                                        }
                                                    </div>
                                                </div>
                                            </div>


                                            <div className='farm-buttons d-flex justify-content-center align-items-center'>
                                                <button className='btn mx-1' onClick={() => setShow(1)} style={{ backgroundColor: `${show == 1 ? "#444c7f" : "transparent"}`, color: `${show == 1 ? "white" : "#444c7f"}`, border: "1px solid #444c7f" }} >Minting</button>
                                                <button className='btn mx-1' onClick={() => setShow(2)} style={{ backgroundColor: `${show == 2 ? "#444c7f" : "transparent"}`, color: `${show == 2 ? "white" : "#444c7f"}`, border: "1px solid #444c7f" }} >Inventory</button>
                                            </div>

                                            {
                                                show === 1 ?
                                                    <div className="col-lg-6 col-md-6 col-12 cat_col farm-mob-col mb-5">
                                                        <div className="card mx-1 minting_card w-100">
                                                            <img src={minting_card} alt="image" className='img-fluid t6567 w-100 h-100' />
                                                            <div className="content">
                                                                <div className='d-flex justify-content-center ai-center text-center'>
                                                                    <h2>Minting</h2>
                                                                </div>
                                                                <div className='board_content'>
                                                                    <div className='w-100'>
                                                                        <div className="name">
                                                                            <h3>Minted: {minted} / {totalSupply}</h3>
                                                                        </div>
                                                                    </div>
                                                                    <div className='bar'>
                                                                        <div className='bg'></div>
                                                                        <div className='cont left_text'>
                                                                            {/* <p>0~10,000</p>
                                                                            <p> 0.001 ETH</p> */}
                                                                        </div>
                                                                        <div className="cont right_text">
                                                                            {/* <p>10,000~50,000</p>
                                                                            <p>1,000~5,000 RICE</p> */}
                                                                            <p>{itemsRange.start}~{itemsRange.end}</p>
                                                                            <p> {price / 1000000000000000000} ETH each</p>
                                                                        </div>
                                                                    </div>
                                                                    <div className='counter d-flex justify-content-center text-center align-items-center'>
                                                                        <button className='' onClick={() => handleQuantity("-")}>-</button>
                                                                        <h2 className='mx-5'>{qty}</h2>
                                                                        <button className='' onClick={() => handleQuantity("+")}>+</button>
                                                                    </div>
                                                                    <div className='mt-2 d-flex justify-content-between'>
                                                                        <div className="name d-flex">
                                                                            <h3 style={{ visibility: "hidden" }}>2,770.8 $RICE &nbsp; </h3>
                                                                            <small style={{ visibility: "hidden" }}> at least <span>BUY</span></small>
                                                                        </div>
                                                                    </div>
                                                                    <button className="btn" onClick={() => Mint()}>Want to MINT</button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    :
                                                    <div className="col-lg-6 col-md-6 col-12 cat_col farm-mob-col mb-5">
                                                        <div className="card mx-1 items_card">
                                                            <img src={items} alt="image" className='img-fluid t6567 h-100' />
                                                            <div className="content rack_1">
                                                                {
                                                                    userNFTs.length > 0 && userNFTs.map((__nft, i) => {
                                                                        console.log("userNFTs", __nft);
                                                                        return <div className="nftCard" key={i}>
                                                                            <div className='text-center w-100'>
                                                                                <img src={__nft?.image} alt="image" style={{ maxWidth: "100px" }} />
                                                                            </div>
                                                                            <div>
                                                                                <p>
                                                                                    {__nft?.name}
                                                                                </p>
                                                                            </div>
                                                                        </div>
                                                                    })

                                                                }
                                                            </div>

                                                            <div className="content rack_2">
                                                                {
                                                                    userNFTs.length > 0 && userNFTs.map((__nft, i) => {
                                                                        console.log("userNFTs", __nft);
                                                                        return <div className="nftCard" key={i}>
                                                                            <div className='text-center w-100'>
                                                                                <img src={__nft?.image} alt="image" style={{ maxWidth: "100px" }} />
                                                                            </div>
                                                                            <div>
                                                                                <p>
                                                                                    {__nft?.name}
                                                                                </p>
                                                                            </div>
                                                                        </div>
                                                                    })

                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                            }

                                        </div>

                                }
                            </>
                            :
                            <>
                                <div className="row justify-content-center align-items-center" style={{ height: "70vh" }}>
                                    <div className="col-lg-6 col-md-6 col-12 cat_col mb-5">
                                        <div className="card connect_card mx-1">
                                            <div className="content" style={{ minHeight: "250px", textAlign: "center", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                                <h1 style={{ color: "#444c7f", fontSize: "40px" }}>Minting Soon!!!</h1>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                    }


                </div>
            </section>
            <Footer />
        </>
    )
}

export default Farm
